import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje, MensajeSiNo } from "../../mensajes2";
import { Dimmer } from "../../spinner";
import {
  validaSoloNumero,
  formatMoneda,
  validaMonto,
} from "../../../util/varios";
import axios from "axios";
import { Checkbox, Input, Textarea } from "../../../ui/inputs/Input";
import { DangerButton, SuccessButton } from "../../../ui/buttons/Button";

export const ActualizarClaseActividades = (props) => {
  let op = require("../../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const anioActu = JSON.parse(localStorage.getItem("anioactu"));
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const btnCancela = useRef();
  const btnAcepta = useRef();
  const [activate, setActivate] = useState(false);
  const [desde, setDesde] = useState(0);
  const txtCodigoCiu = useRef();
  const txtIdactividad = useRef();
  const txtAlicuota = useRef();
  const txtDescripcionActi = useRef();
  const txtAnios = useRef();
  const txtMinimo = useRef();
  const txtActualizada = useRef();
  const txtCodActividad = useRef();
  const [operacion, setOperacion] = useState(0);
  const [values, setValues] = useState({
    idactividad: "",
    codigoactividad: "",
    descripcion: "",
    alicuota: "",
    minimo: "",
    actualizada: "",
    anios: "",
    codigociu: "",
  });

  const actualizarClasificador = () => {
    let endpoint = `${op.conexion}/api/industria/actualizaractividad`;
    let body;
    setActivate(true);
    body = {
      operacion: operacion,
      nid:
        txtIdactividad.current.value !== null
          ? parseInt(txtIdactividad.current.value)
          : 0,
      codact: txtCodActividad.current.value,
      des: txtDescripcionActi.current.value.trim(),
      ali: txtAlicuota.current.value.replace(/\./g, "").replace(",", "."),
      mini: txtMinimo.current.value.replace(/\./g, "").replace(",", "."),
      actua: txtActualizada.current.checked,
      ani: txtAnios.current.value.trim(),
      codciu: txtCodigoCiu.current.value,
    };

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (props.operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro creado correctamente.",
              icono: "exito",
            });
          } else if (props.operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro modificado correctamente.",
              icono: "exito",
            });
          } else if (props.operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro eliminado correctamente.",
              icono: "exito",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const cerrarModal = () => {
    if (
      mensaje.texto === "registro creado correctamente." ||
      mensaje.texto === "registro modificado correctamente." ||
      mensaje.texto === "registro eliminado correctamente."
    ) {
      props.onHideCancela();
      props.onHideRenderizar();
      blanquear();
      setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
      setMensaje({ mostrar: false, titulo: ".", texto: "", icono: "" });
    }
    if (desde === 3) {
      props.onHideAcepta();
    }
  };

  const onChange = (event) => {
    if (event.target.name === "textareadescrip") {
      event.target.value = event.target.value.toUpperCase();
    }
  };

  const handleInputChange = (event) => {
    if (event.which === 13) {
      if (event.target.id === "inputCodigo") {
        txtCodActividad.current.focus();
      } else if (event.target.id === "inputCodigoActi") {
        if (event.target.value.length === 1) {
          txtCodActividad.current.value = "0000" + event.target.value;
        } else if (event.target.value.length === 2) {
          txtCodActividad.current.value = "000" + event.target.value;
        } else if (event.target.value.length === 3) {
          txtCodActividad.current.value = "00" + event.target.value;
        } else if (event.target.value.length === 4) {
          txtCodActividad.current.value = "0" + event.target.value;
        }

        txtCodigoCiu.current.focus();
      } else if (event.target.id === "inputCodigoCiu") {
        txtAnios.current.focus();
      } else if (event.target.id === "inputAnio") {
        if (parseInt(event.target.value) > parseInt(anioActu)) {
          txtAnios.current.value = anioActu;
        }

        txtDescripcionActi.current.focus();
      } else if (event.target.id === "inputDescripcion") {
        txtAlicuota.current.focus();
      } else if (event.target.id === "inputActualizada") {
        btnAcepta.current.focus();
      }
    } else if (typeof event.which === "undefined") {
      return false;
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const handleInputMontoChange = (event) => {
    validaMonto(event);
    if (
      event.target.value === "" ||
      parseFloat(
        event.target.value.trim().replace(/\./g, "").replace(",", ".")
      ) === 0.0
    ) {
      event.target.value = "0,00";
    }
    if (event.which >= 37 && event.which <= 40) {
      event.preventDefault();
    }
    if (event.which === 13) {
      if (event.target.id === "inputAlicuota") {
        txtMinimo.current.focus();
      } else if (event.target.id === "inputMinimo") {
        txtActualizada.current.focus();
      }
    }
    let e = event.target.value
      .replace(/\D/g, "")
      .replace(/([0-9])([0-9]{2})$/, "$1.$2")
      .replace(/\B(?=(\d{3})+(?!\d)\.?)/g, ",");

    return formatMoneda(e);
  };

  const handleInputNumChange = (event) => {
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.which === 13) {
        if (event.target.id === "inputAnio") {
          txtDescripcionActi.current.focus();
          if (parseInt(event.target.value) > parseInt(anioActu)) {
            txtAnios.current.value = anioActu;
          }
        }
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const blanquear = () => {
    setValues({
      idactividad: "",
      codigoactividad: "",
      descripcion: "",
      alicuota: "",
      minimo: "",
      actualizada: "",
      anios: "",
      codigociu: "",
    });
    setOperacion(0);
    setActivate(false);
    setDesde(0);
  };

  const onChangeValidar = () => {
    var sigue = true;
    setDesde(0);
    if (operacion === 1 || operacion === 2) {
      if (txtCodActividad.current.value.trim() === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe suministrar el codigo",
          icono: "informacion",
        });
        txtCodActividad.current.focus();
        sigue = false;
      } else if (txtCodigoCiu.current.value.trim() === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe suministrar el codigo Ciu.",
          icono: "informacion",
        });
        txtCodigoCiu.current.focus();
        sigue = false;
      } else if (txtAnios.current.value.trim() === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe suministrar el Año.",
          icono: "informacion",
        });
        txtAnios.current.focus();
        sigue = false;
      } /* else if (parseInt(txtAnios.current.value.trim()) > parseInt(anioActu)) {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "El año no debe ser mayor al año en curso.",
          icono: "informacion",
        });
        txtAnios.current.focus();
        sigue = false;
      } */ else if (txtDescripcionActi.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe suministrar la Descripcion.",
          icono: "informacion",
        });
        txtDescripcionActi.current.focus();
        sigue = false;
      } else if (
        txtAlicuota.current.value === "0,00" ||
        txtAlicuota.current.value === ""
      ) {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe suministrar el Alicuota.",
          icono: "informacion",
        });
        txtAlicuota.current.focus();
        sigue = false;
      } else if (
        txtMinimo.current.value === "0,00" ||
        txtMinimo.current.value === ""
      ) {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe suministrar el Minimo.",
          icono: "informacion",
        });
        txtMinimo.current.focus();
        sigue = false;
      }
      if (sigue) {
        setActivate(true);
        actualizarClasificador();
      }
    } else {
      actualizarClasificador();
    }
  };
  const cancelar = () => {
    blanquear();
    props.onHideCancela();
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setOperacion(props.operacion);
        if (props.operacion !== 1) {
          setValues(props.actividad);
        }
      }}
    >
      <Modal.Header className="azulGradiant ">
        <h3 className="fw-bold m-0">
          {operacion === 1
            ? "Agregar Clasificador. - Actividad Economica."
            : operacion === 2
            ? "Editar Clasificador. - Actividad Economica."
            : operacion === 3
            ? "Eliminar Clasificador. - Actividad Economica."
            : "Consultar Clasificador. - Actividad Economica."}
        </h3>
        <a
          type="button"
          ref={btnCancela}
          className="fw-bold text-light fs-6"
          onClick={cancelar}
        >
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body>
        <fieldset className="col-12 m-0 p-2 d-flex flex-wrap align-items-center border-azul rounded">
          <legend className="float-none m-0 w-auto ">
            Clasificador de Actividades Económicas
          </legend>
          <div className="col-6 col-lg-3 m-0 mb-2 p-0">
            <Input
              label="Código:"
              name="codigo"
              disabled
              defaultValue={values.idactividad.trim()}
              onKeyUp={handleInputChange}
              onBlur={handleInputChange}
              id="inputCodigo"
              ref={txtIdactividad}
            />
          </div>
          <div className="col-6 col-lg-4 m-0 mb-2 p-0 pl-2">
            <Input
              label="Código Actividad:"
              name="codigoActividad"
              maxLength={5}
              disabled={
                operacion === 1 ? false : operacion === 2 ? false : true
              }
              id="inputCodigoActi"
              defaultValue={values.codigoactividad.trim()}
              onKeyUp={handleInputChange}
              onBlur={handleInputChange}
              ref={txtCodActividad}
            />
          </div>
          <div className="col-6 col-lg-3 m-0 mb-2 p-0 pl-lg-2">
            <Input
              label="Código CIU:"
              disabled={
                operacion === 1 ? false : operacion === 2 ? false : true
              }
              id="inputCodigoCiu"
              defaultValue={values.codigociu.trim()}
              onKeyUp={handleInputChange}
              onBlur={handleInputChange}
              ref={txtCodigoCiu}
            />
          </div>
          <div className="col-6 col-lg-2 m-0 mb-2 p-0 pl-2">
            <Input
              label="Año:"
              disabled={
                operacion === 1 ? false : operacion === 2 ? false : true
              }
              maxLength={4}
              id="inputAnio"
              defaultValue={values.anios !== null ? values.anios.trim() : ""}
              onKeyUp={handleInputNumChange}
              onBlur={handleInputNumChange}
              ref={txtAnios}
            />
          </div>
          <div className="col-12 m-0 mb-2 p-0">
            <Textarea
              label="Descripción:"
              name="textareadescrip"
              style={{ height: 60 }}
              disabled={
                operacion === 1 ? false : operacion === 2 ? false : true
              }
              id="inputDescripcion"
              defaultValue={values.descripcion.trim()}
              onKeyUp={handleInputChange}
              onBlur={handleInputChange}
              onChange={onChange}
              ref={txtDescripcionActi}
            />
          </div>
          <div className="col-4 m-0 p-0">
            <Input
              label="Alicuota %:"
              inputClassName = 'text-end'
              name="alicuota"
              disabled={
                operacion === 1 ? false : operacion === 2 ? false : true
              }
              ref={txtAlicuota}
              id="inputAlicuota"
              defaultValue={formatMoneda(
                values.alicuota.toString().replace(".", ","),
                ",",
                ".",
                2
              )}
              onKeyUp={handleInputMontoChange}
              onBlur={handleInputMontoChange}
            />
          </div>
          <div className="col-8 col-lg-4 m-0 p-0 pl-2">
            <Input
              label="Minimo Tributable:"
              inputClassName = 'text-end'
              name="minimo"
              disabled={
                operacion === 1 ? false : operacion === 2 ? false : true
              }
              ref={txtMinimo}
              id="inputMinimo"
              defaultValue={formatMoneda(
                values.minimo.toString().replace(".", ","),
                ",",
                ".",
                2
              )}
              onKeyUp={handleInputMontoChange}
              onBlur={handleInputMontoChange}
            />
          </div>
          <div className="col-3 m-0 mt-2 mt-lg-0 p-0 pl-2">
            <Checkbox
              label="Actualizada"
              id="flexCheckDefault"
              disabled={
                operacion === 1 ? false : operacion === 2 ? false : true
              }
              ref={txtActualizada}
              defaultChecked={props.actividad && props.actividad.actualizada}
              onKeyUp={handleInputChange}
              onBlur={handleInputChange}
            />
          </div>
        </fieldset>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton
          ref={btnAcepta}
          disabled={operacion === 4 ? true : false}
          onClick={onChangeValidar}
        >
            Aceptar
        </SuccessButton>
        <DangerButton
          ref={btnCancela}
          onClick={cancelar}
        >
            Cancelar
        </DangerButton>
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({
                mostrar: false,
                titulo: "",
                texto: "",
                icono: "",
              });
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <Dimmer active={activate} inverted></Dimmer>
    </Modal>
  );
};
